export default __webpack_public_path__ + "static/media/gallery_11.f51b6506.jpg";